import { inputClasses as muiInputClasses } from '@mui/material'

export const inputClasses = {
  ...muiInputClasses,
  label: {
    shrink: 'input-label-shrink',
    placement: {
      inside: 'input-label-inside',
      outside: 'input-label-outside',
    },
  },
  state: {
    focused: 'input-focused',
    error: 'input-error',
    disabled: 'input-disabled',
    startAdornment: 'input-start-adornment',
    endAdornment: 'input-end-adornment',
  },
}

export const defaultAllowedKeys = [
  'Tab',
  'Enter',
  'Backspace',
  'Delete',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  'Home',
  'End',
  'Escape',
  'Shift',
]
